
export default function About() {
  const values = [
    {
      icon: 'ri-medal-line',
      title: 'Quality Results',
      description: 'Professional-grade equipment and techniques for superior cleaning'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Reliable Scheduling',
      description: 'We show up on time and respect your schedule'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Respect for Your Property',
      description: 'Careful protection of landscaping and surrounding areas'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Fair, Clear Pricing',
      description: 'Transparent quotes with no hidden fees or surprises'
    }
  ];

  return (
    <section id="about" className="relative py-24 overflow-hidden">
      {/* Diagonal Background Split */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-white"></div>
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-br from-cyan-50 to-blue-50 transform skew-x-12 translate-x-1/4"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-extrabold text-blue-900 mb-6">
              About X-Treme Aqua
            </h2>
            <div className="w-16 h-1 bg-gradient-to-r from-cyan-400 to-blue-400 mb-8"></div>
            
            <p className="text-lg text-blue-800 leading-relaxed mb-6">
              X-Treme Aqua Pressure Cleaning is a Miami-based pressure cleaning service focused on quality, speed, and clean finishes. We treat every job like it's our own property—showing up on time, communicating clearly, and delivering results you can see immediately.
            </p>

            <p className="text-base text-blue-700 leading-relaxed mb-8">
              Whether you need your driveway restored, your home's exterior refreshed, or your commercial property maintained, we bring the same level of care and attention to detail to every project.
            </p>

            <div className="flex items-center space-x-3 text-blue-800 italic">
              <div className="w-12 h-0.5 bg-orange-500"></div>
              <span className="font-medium">Your Miami Pressure Cleaning Experts</span>
            </div>
          </div>

          {/* Right - Value Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-blue-100"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-blue-400 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${value.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-blue-900 mb-2">
                  {value.title}
                </h3>
                <p className="text-sm text-blue-700 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
